import { LoggerFactory } from 'nordic/logger';
import { misc } from '@credits-utils/constants';

const TRACKING_LOGGER = 'tracking-utils';
const TRACKING_CONTEXT = 'utils/tracking';
const { LOGGER_TRANSACTION, LOGGER_EXECUTION } = misc;

const logger = LoggerFactory(TRACKING_LOGGER);

const sendMelidataTrack = ({ type, path, event_data: eventData = {} }) => {
  // Send Melidata track with provided type, path and event data
  melidata('cleanAndSend', type, { path, data: eventData });
};

const sendGoogleAnalyticsTrack = ({
  hitType,
  eventCategory,
  eventAction,
  eventLabel,
  eventValue,
  custom_dimensions: customDimensions,
}) => {
  // Prepare custom dimensions for Google Analytics track
  let gaCustomDimensions = {};
  if (customDimensions) {
    gaCustomDimensions = Object.keys(customDimensions).reduce((acc, cdIndex) => {
      acc[`dimension${cdIndex}`] = customDimensions[cdIndex];
      return acc;
    }, {});
  }

  meli_ga(
    'send',
    {
      hitType,
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      ...gaCustomDimensions,
    },
  );
};

const trackAction = (action) => {
  if (typeof action.analytics === 'object' && action.analytics !== null) {
    try {
      sendGoogleAnalyticsTrack(action.analytics);
    } catch (error) {
      logger.error(`${LOGGER_TRANSACTION.FAILED} - fail to track GoogleAnalytics`, {
        context: TRACKING_CONTEXT,
        execution: LOGGER_EXECUTION.FAILED,
        analytics: action.analytics,
      }, error);
    }
  }

  if (typeof action.melidata === 'object' && action.melidata !== null) {
    try {
      sendMelidataTrack(action.melidata);
    } catch (error) {
      logger.error(`${LOGGER_TRANSACTION.FAILED} - fail to track Melidata`, {
        context: TRACKING_CONTEXT,
        execution: LOGGER_EXECUTION.FAILED,
        melidata: action.melidata,
      }, error);
    }
  }
};

export {
  trackAction,
  sendGoogleAnalyticsTrack,
  sendMelidataTrack,
};
